export const color = {
  redMain: '#E56B6B',
  grey: '#4D5061',
  whiteBlue: '#FEFEFF',
  veryLightPink: '#F7D3CD',
  darkBlue: '#30323D',
  lightGrey: '#F8F1FF',
  oceanBlue: '#087E8B',
  blackOpacity: 'rgba(0,0,0,0.25)',
  darkBlackOpacity: 'rgba(0,0,0,0.8)',
  lightBlackOpacity: 'rgba(0,0,0,0.1)',
  lightWhiteOpacity: 'rgba(255,255,255,0.35)',
  almostWhite: 'rgb(240, 240, 240)',
  veryLightGrey: 'rgb(200, 200, 200)',

  content: 'rgb(40, 40, 40)',
  content2: 'rgb(60, 60, 60)',
  content3: 'rgb(0, 0, 0)',
  background: 'rgb(255, 255, 255)',
  background3: 'rgb(240, 240, 240)',
  background4: 'rgb(220, 220, 220)',

  greyButtonHover: 'rgb(220, 220, 220)',
}
